/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { AnyFunction } from 'global';
import type { THue, TSize } from 'volta/utils/style-utils';

interface AlertIconSignature {
  Args: {
    color?: THue;
    disabled?: boolean;
    onClick?: AnyFunction;
    primaryIcon?: string;
    secondaryIcon?: string;
    secondaryIconColor?: THue;
    size?: TSize;
    subtle?: boolean;
    tooltip?: string;
    tooltipSubtext?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const AlertIconComponent = templateOnly<AlertIconSignature>('AlertIcon');

export default AlertIconComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    AlertIcon: typeof AlertIconComponent;
    'alert-icon': typeof AlertIconComponent;
  }
}
